// al-same-stone.js : repli de la section AL Même pierre quand la pierre est inconnue.
// Charge les recommandations Shopify « related » (rendues par la même section), retire le
// produit courant et les produits du lot, met les autres types avant le même type, garde N cartes.
if (!customElements.get("al-same-stone")) {
  customElements.define(
    "al-same-stone",
    class AlSameStone extends HTMLElement {
      connectedCallback() {
        const start = () => this.load();
        if (!("IntersectionObserver" in window)) return start();
        const io = new IntersectionObserver(
          (entries) => {
            if (!entries[0].isIntersecting) return;
            io.disconnect();
            start();
          },
          { rootMargin: "0px 0px 400px 0px" }
        );
        io.observe(this);
      }

      load() {
        fetch(this.dataset.url)
          .then((response) => response.text())
          .then((text) => {
            const doc = new DOMParser().parseFromString(text, "text/html");
            const exclude = this.dataset.exclude || ",";
            const type = this.dataset.type || "";
            const limit = Number(this.dataset.limit) || 4;
            const items = Array.from(doc.querySelectorAll("[data-al-reco-items] > [data-id]")).filter(
              (el) => !exclude.includes("," + el.dataset.id + ",")
            );
            const ordered = [
              ...items.filter((el) => el.dataset.type !== type),
              ...items.filter((el) => el.dataset.type === type),
            ].slice(0, limit);
            if (!ordered.length) return;
            const grid = this.querySelector("[data-al-grid]");
            ordered.forEach((el) => grid.appendChild(document.importNode(el, true)));
            const inner = this.querySelector("[data-al-inner]");
            if (inner) inner.style.display = "";
          })
          .catch((error) => console.error(error));
      }
    }
  );
}
